import React from "react";

const Header = () => {
    return (
        <div className={"row-header"}>
            <p className={"page-header"}>Trello Dashboard</p>
        </div>
    );
};

export default Header;